export const PATH_SANTE_ANIMALE = "/sante-animale";
export const KEY_SANTE_ANIMALE = "sante-animale";
export const TITLE_SANTE_ANIMALE = "Santé Animale";

export const PATH_SANTE_ANIMALE_MALADIE_REFERENCE = `${PATH_SANTE_ANIMALE}/maladie-reference`;
export const KEY_SANTE_ANIMALE_MALADIE_REFERENCE = `${KEY_SANTE_ANIMALE}/maladie-reference`;
export const TITLE_SANTE_ANIMALE_MALADIE_REFERENCE = "Maladies de Référence";

export const PATH_SANTE_ANIMALE_MEDICAMENT_REFERENCE = `${PATH_SANTE_ANIMALE}/medicament-reference`;
export const KEY_SANTE_ANIMALE_MEDICAMENT_REFERENCE = `${KEY_SANTE_ANIMALE}/medicament-reference`;
export const TITLE_SANTE_ANIMALE_MEDICAMENT_REFERENCE = "Médicaments de Référence";

export const PATH_SANTE_ANIMALE_VACCIN_REFERENCE = `${PATH_SANTE_ANIMALE}/vaccin-reference`;
export const KEY_SANTE_ANIMALE_VACCIN_REFERENCE = `${KEY_SANTE_ANIMALE}/vaccin-reference`;
export const TITLE_SANTE_ANIMALE_VACCIN_REFERENCE = "Vaccins de Référence";

export const PATH_SANTE_ANIMALE_VACCIN = `${PATH_SANTE_ANIMALE}/vaccin`;
export const KEY_SANTE_ANIMALE_VACCIN = `${KEY_SANTE_ANIMALE}/vaccin`;
export const TITLE_SANTE_ANIMALE_VACCIN = "Vaccins";

export const PATH_SANTE_ANIMALE_VACCINATION = `${PATH_SANTE_ANIMALE}/vaccination`;
export const KEY_SANTE_ANIMALE_VACCINATION = `${KEY_SANTE_ANIMALE}/vaccination`;
export const TITLE_SANTE_ANIMALE_VACCINATION = "Vaccinations";
